export default __webpack_public_path__ + "static/media/img-0309-brazil-premium-face.9241c920.png";